import StudentExerciseAPI from '@/apis/business/student/student-exercise-api.js'
import StudentExamAPI from '@/apis/business/student/student-exam-api.js'
import MISAStoreAPI from '@/apis/business/MISAStore/exercise-store-api.js'
import ExerciseReferAPI from '@/apis/business/student/exercise-refer-api.js'
import { HttpStatusCode } from '@/common/constant'
import Enumeration from '@/common/enumeration.js'
import { formatText } from '@/utils/text'
import { handleMappingAnswer } from '@/views/pages/teacher/storage/create/common/common.js'

export default {
  namespaced: true,
  state: {
    studentExercises: [],
    allStudentExercise: [],
    studentExercise: {},
    submitExercise: {}, // param lưu kết quả nộp bài
    selectedQuestion: 1, // Index câu hỏi đang được chọn
    exerciseCard: {},
    totalExercise: null, // tổng số bản ghi trả về
    countExercise: {},
    tabActive: Enumeration.TabActive.All,
    tabActiveClassroom: Enumeration.TabActive.All,
    exerciseSaveDraft: '', // ID của bản ghi bài tập lưu nháp
    isReplay: true, // Học sinh muốn làm lại bài hay không
    studentExam: null, // Dữ liệu bài kiểm tra của học sinh

    // BNDung
    isAnswer: false, // khi click vào item bài làm hoặc lời giải thì field này để xác định
    questionAttachment: null,
    answerAttachment: null,
    correctAnswerAttachment: null,
    answerAttachments: [],
    correctAnswerAttachments: [],
    bothAttachment: [],
    summaryResults: {},
    questions: null,
    submitAnswer: 0,
    deadline: new Date(),
    isPreviewAnswer: true,
    status: 0,
    answerType: 0,
    note: '',
    studentExerciseID: '',
    exerciseDetailType: 0, // dạng bài tập chi tiết
    submitDetails: [], // lưu lại danh sách chi tiết bài tập ở bảng
    titleExercise: '',
    mainAttachment: null,
    correctAnswerNote: '',
    isExpired: false,
    isClosePopup: false,
    fileManager: [],

    // tt dung 1
    subject: '',
    grade: '',

    // PBac
    exercise: {}, // Dữ liệu bài tập
    isClickTabIndex: 0, // State lưu trạng thái để gọi chéo
    exerciseThemeIndex: 0, // theme mặc định giao diện làm bài tập
    isNotDoneExercise: false, // học sinh đang làm bài dở hay không
    tabActiveV2: Enumeration.TabActiveV2.NotFinish,
    exercisesNotFinish: {}, // Danh sách bài tập chưa hoàn thành
    exercisesFinishedHaveResult: {}, // Danh sách bài tập đã hoàn thành có kết quả
    exercisesFinishedNoResult: {}, // Danh sách bài tập đã hoàn thành chưa có kết quả
    selectedQuestionIndex: 0, // Index bài tập đang được chọn

    // ttlong
    videoHocMai: {}, // id khóa học, bài học, video,... của bài giảng học mãi
    isResetExercise: false,
    subjects: [], // danh sách môn học của bài tập tổng hợp
    questionCompoundExercises: [], // danh sách câu hỏi bài tập tổng hợp
    isCompoundExercise: false,
    indexSubjectSelected: 0,
    autoScrollState: false
  },

  getters: {
    submitStatus (state) {
      if (state.studentExercises.length > 0) {
        state.studentExercises.forEach((element) => {
          if (element.Status === Enumeration.StudentExerciseStatus.YetSubmit) {
            if (new Date(element.Deadline) < new Date()) {
              element.Status = Enumeration.StudentExerciseStatus.Expired
            } else {
              var diffDate =
                (new Date(element.Deadline) - new Date()) / (1000 * 3600 * 24)
              element.DiffDate = Math.ceil(diffDate)
            }
          }
        })
      }

      return {
        yetSubmit: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.YetSubmit
        ).length,
        submited: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.Submitted
        ).length,
        expired: state.studentExercises.filter(
          (item) => item.Status === Enumeration.StudentExerciseStatus.Expired
        ).length
      }
    },
    getExerciseSubmit (state) {
      return state.submitExercise
    },

    questionSidebars (state) {
      let questions = state.submitExercise.Questions

      questions = questions?.map(question => {
        let isDone = false
        const QUESTION_TYPE = Enumeration.QuestionType
        switch (question.Type) {
          case QUESTION_TYPE.Select:
          case QUESTION_TYPE.Yesorno:
            isDone = question.Answers.some(answer => answer.Correct)
            break
          case QUESTION_TYPE.Fill:
            isDone = question.Answers.some(answer => answer.Content)
            break
          case QUESTION_TYPE.Essay:
            if (question.Answers?.length) {
              isDone = !!question.Answers[0].Content || (question.Answers[0].AnswerAttachment?.length > 0)
            }
        }
        question.Done = isDone
        return question
      })
      state.submitExercise.Questions = questions
      return questions
    },
    /**
     * Tổng số câu hỏi
     * @param {*} state
     * @returns
     */
    numberQuestion (state) {
      return state.exerciseCard.QtyQuestion
    },

    /**
     * Số lượng câu đã làm
     * @param {*} state
     * @returns
     */
    numberAnswers (state) {
      if (state.submitExercise.Questions?.length > 0) {
        const listAnswers = state.submitExercise.Questions
        var count = 0
        listAnswers.forEach(function (item) {
          if (item.Done) {
            count++
          }
        })
      }
      return count
    },

    /**
     * kiểm tra sẽ show màn hình preview hay màn compare
     */
    checkShowPreview (state) {
      if (state.answerType === Enumeration.AnswerType.Upload) {
        return true
      } else {
        return false
      }
    },

    /**
     * kiểm tra xem thử có được xem lời giải hay không ?
     */
    viewAnswers (state) {
      if (
        state.status === Enumeration.StudentExerciseStatus.Submitted ||
        state.submitAnswer === 0 ||
        new Date(state.deadline) > new Date()
      ) {
        return true
      } else {
        return false
      }
    }
  },

  mutations: {
    /**
     * set môn học cho bài tập tổng hợp
     * @param {*} state
     * @param {*} param
     */
    setIndexSubjectSelected (state, param) {
      state.indexSubjectSelected = param
    },
    /**
     * set môn học cho bài tập tổng hợp
     * @param {*} state
     * @param {*} param
     */
    setSubjects (state, param) {
      state.subjects = param
    },
    /**
     * setgiá trị cho biến kiểm tra có bài tập tổng hợp
     * @param {*} state
     * @param {*} param
     */
    setIsCompoundExercise (state, param) {
      state.isCompoundExercise = param
    },
    /**
     * set câu hỏi cho bài tập tổng hợp
     * @param {*} state
     * @param {*} param
     */
    setQuestionCompoundExercises (state, param) {
      state.questionCompoundExercises = param
    },
    setIsResetExercise (state, param) {
      state.isResetExercise = param
    },
    /**
     * set file manager
     * @param {*} state
     * @param {*} param
     */
    setFileManager (state, param) {
      state.fileManager = param
    },

    /**
     * đóng popup
     * @param {*} state
     */
    closePopup (state, param) {
      state.isClosePopup = param
    },

    /**
     * Cập nhật dữ liệu bài kiểm tra
     * @param {} state
     * @param {*} examPeriod
     */
    setDataExamDefault (state, examPeriod) {
      state.studentExam = examPeriod
    },
    // thực hiện lưu file thông tin
    setFileInformation (state, fileInformation) {
      state.fileInformation = fileInformation
    },
    // update exercise card
    setExerciseCard (state, exerciseCard) {
      state.exerciseCard = exerciseCard
    },

    updateCheckedForQuestion (state, param) {
      const tmpQuestion = state.submitExercise?.Questions[param.SortOrder - 1]
      tmpQuestion.IsCheck = param.IsCheck
    },

    // set lại môn học sinh chọn
    setSubject (state, subject) {
      state.subject = subject
    },
    // set lại lớp của học sinh
    setGrade (state, grade) {
      state.grade = grade
    },

    // thay đổi bài làm trên preview
    setMainAttachment (state, mainAttachment) {
      state.mainAttachment = mainAttachment
    },

    // set bài làm
    setIsAnswer (state, param) {
      state.isAnswer = param
    },

    // set tổng số bản ghi
    setTotalExercise (state, totalExercise) {
      state.totalExercise = totalExercise
    },

    // cập nhật danh sách lớp theo học sinh
    setStudentExercise (state, studentExercises) {
      state.studentExercises = studentExercises
    },

    // cập nhật danh sách bài tập theo học sinh
    setAllStudentExercise (state, allStudentExercise) {
      state.allStudentExercise = allStudentExercise
    },

    // cập nhật thông tin bài tập của học sinh
    setStudentExerciseByID (state, studentExercise) {
      state.studentExercise = studentExercise
    },
    // cập nhật làm lại bài
    setIsReplay (state, isReplay) {
      state.isReplay = isReplay
    },
    /**
     * @description cập nhật danh sách lớp theo học sinh
     * @author BNDung
     */
    setExerciseDetailType (state, exerciseDetailType) {
      state.exerciseDetailType = exerciseDetailType
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     * @author BNDung
     */
    setIsExpired (state, isExpired) {
      state.isExpired = isExpired
    },

    /**
     * @description cập nhật danh sách lớp theo học sinh
     * @author BNDung
     */
    setSubmitExercise (state, submitExercise) {
      state.submitExercise = submitExercise
    },

    /**
     * @description cập nhật thông tin file prevew file
     * @author BNDung
     *  */
    setPreviewAttachment (state, param) {
      // file bài làm
      if (typeof param?.AnswerAttachment !== 'undefined') {
        state.mainAttachment = param?.AnswerAttachment[0]
      }
      // file lời giải
      if (
        typeof param.CorrectAnswerAttachment !== 'undefined' &&
        param.CorrectAnswerAttachment.length !== 0 &&
        param?.AnswerAttachment.length !== 0
      ) {
        state.bothAttachment = param?.CorrectAnswerAttachment[0]
        state.isAnswer = true
      } else if (
        state.bothAttachment?.length === 0 &&
        typeof param.QuestionAttachment !== 'undefined' &&
        param.CorrectAnswerAttachment.length === 0
      ) {
        // nếu không có lời giải thì load đề bài lên trước
        state.bothAttachment = param?.QuestionAttachment
      }

      // thêm đề bài
      if (
        typeof param?.QuestionAttachment !== 'undefined' &&
        param?.QuestionAttachment.length !== 0
      ) {
        state.questionAttachment = param?.QuestionAttachment
      }

      // thêm đáp án
      if (
        typeof param?.AnswerAttachment !== 'undefined' &&
        param?.AnswerAttachment.length !== 0
      ) {
        state.answerAttachment = param?.AnswerAttachment[0]
        state.answerAttachments = param?.AnswerAttachment
      }

      // thêm lời giải
      if (
        typeof param?.CorrectAnswerAttachment !== 'undefined' &&
        param?.CorrectAnswerAttachment.length !== 0
      ) {
        state.correctAnswerAttachment = param?.CorrectAnswerAttachment[0]
        state.correctAnswerAttachments = param?.CorrectAnswerAttachment
      }

      state.questions = param?.Questions
      state.correctAnswerNote = param?.CorrectAnswerNote
      // set state summarry để lấy số lượng câu trả lời đúng, sai, chưa làm
      state.summaryResults = param?.SummaryResults
      state.submitAnswer = param?.SubmitAnswer
      state.deadline = param?.Deadline

      state.status = param?.Status
      state.answerType = param?.AnswerType
      state.note = param?.Note
      state.studentExerciseID = param?.StudentExerciseID
      if (param?.SubmitDetail !== 'undefined') {
        state.submitDetails = param?.SubmitDetail
      }
      state.titleExercise = param?.Title
      state.studentExercise.RefAttachment = param?.RefAttachment
      state.studentExercise.IsCompensate = param?.IsCompensate
      state.studentExercise.Replay = param?.Replay
    },

    // thực hiện thay đổi lời giải khi click vào file
    setCorrectAnswerAttachment (state, param) {
      state.correctAnswerAttachment = param
    },

    // thực hiện thay đổi lời giải khi click vào file
    setAnswerAttachment (state, param) {
      state.answerAttachment = param
    },

    // thực hiện thay đổi lời giải và bài làm khi click vào file
    setBothAttachment (state, param) {
      state.bothAttachment = param
    },

    // show màn hình preview answer theo dữ liệu
    setPreviewAnswer (state, param) {
      state.isPreviewAnswer = param
    },

    // cập nhật câu hỏi được chọn
    setSelectedQuestion (state, sortOrder) {
      state.selectedQuestion = sortOrder
    },

    setAutoScrollState (state, value) {
      state.autoScrollState = value
    },

    setVideoHocMai (state, videoHocMai) {
      state.videoHocMai = videoHocMai
    },
    // cập nhật câu trả lời cho câu hỏi
    updateAnswerForQuestion (state, param) {
      const tmpSubmit = state.submitExercise?.Questions.filter(
        (item) => item.SortOrder === param.sortOrderQuestion
      )

      // Đối với dạng câu hỏi Yes/No
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Yesorno) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          } else {
            item.Correct = false
          }
        })
      }

      // Đối với dạng câu hỏi chọn nhiều đáp án
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Select) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Correct = !item.Correct
          }
        })
      }

      // Đối với dạng câu hỏi điền từ vào chỗ trống
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Fill) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            if (param.contentAnswer !== '') {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
          if (item.Correct === true) {
            tmpSubmit[0].Done = true
          }
        })
      }

      // Đối với dạng câu hỏi tự luận
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Essay) {
        tmpSubmit[0].Answers.forEach(function (item) {
          if (item.SortOrder === param.sortOrderAnswer) {
            item.Content = param.contentAnswer
            item.AnswerAttachment = param.attachItems
            if (param.contentAnswer !== '' || param.attachItems?.length > 0) {
              item.Correct = true
            } else {
              item.Correct = false
            }
          }
        })
      }

      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) {
        tmpSubmit[0].MappingAnswer = param.correctAnswer
        if (tmpSubmit[0].MappingAnswer.length) {
          tmpSubmit[0].Done = true
          tmpSubmit[0].Answers.map(answer => {
            answer.Correct = true
            return answer
          })
        } else {
          tmpSubmit[0].Answers.map(answer => {
            answer.Correct = false
            return answer
          })
        }
      }
      if (tmpSubmit[0].Type === Enumeration.QuestionType.Pairing) { return }
      tmpSubmit[0].Done = false
      // Set lại trạng thái câu hỏi đã được trả lời hay chưa
      tmpSubmit[0].Answers.forEach(function (item) {
        if (item.Correct === true) {
          tmpSubmit[0].Done = true
        }
      })
    },

    // clone dữ liệu câu hỏi sang param submit để nộp bài
    cloneExerciseCardToSubmitExercise (state, exerciseCard) {
      state.exerciseCard = { ...exerciseCard }
      if (exerciseCard.ParentQuestions?.length > 0) {
        exerciseCard.ParentQuestions?.forEach((item) => {
          const groupQuestion = exerciseCard.Questions.filter(
            (question) => question.ParentID === item.SortOrder
          )
          if (groupQuestion.length > 0) {
            const startIndex = groupQuestion[0].SortOrder
            const endIndex = groupQuestion[groupQuestion.length - 1].SortOrder

            let numberQuestion = formatText(startIndex, 2, '0')
            if (endIndex && startIndex !== endIndex) {
              numberQuestion = `${numberQuestion} - ${formatText(
                endIndex,
                2,
                '0'
              )}`
            }
            item.ParentName = numberQuestion
          }
        })
      }
      state.submitExercise = {
        SubmitExerciseID: state.exerciseSaveDraft,
        ExerciseCardID: exerciseCard.ExerciseCardID,
        StudentExerciseID: exerciseCard.StudentExerciseID,
        Note: exerciseCard.Note,
        Status: 0,
        Replay: exerciseCard.Replay,
        Questions: [],
        ParentQuestions: [],
        SubmitAnswer: exerciseCard.SubmitAnswer,
        Background: exerciseCard.Background,
        Time: exerciseCard.Time
      }
      state.submitExercise.ParentQuestions = exerciseCard.ParentQuestions
      exerciseCard.Questions =
        exerciseCard.Questions !== undefined ? exerciseCard.Questions : []
      exerciseCard.Questions.forEach(function (question) {
        let ParentQuestion = null
        if (!window.location.search.includes('isCompound') && question.ParentID) {
          ParentQuestion = exerciseCard.ParentQuestions?.find(
            (item) => item.SortOrder === question.ParentID
          )
        } else {
          ParentQuestion = question.ParentQuestion
        }
        const { Type, SortOrder, NumberNo, Done, Content, Attachments, MappingAnswer, MappingAnswerTeacher, Hint, ParentID } = question
        const questionSubmit = {
          Type,
          SortOrder,
          NumberNo,
          Done,
          Hint,
          Content,
          Attachments,
          ParentID: question.ParentID,
          Answers: [],
          CorectAnswers: [],
          ParentQuestion,
          MappingAnswerColumnName: MappingAnswer?.AnswerColumnName,
          MappingAnswer: MappingAnswer?.CorrectAnswer || [],
          MappingAnswerTeacher: MappingAnswerTeacher
        }
        /**
         * Care lỗi dữ liệu do bug trước đó từ tính năng trích rút
         * Nếu là câu tự luận và không có đáp án thì push 1 đáp án default vào để binding dữ liệu
         * @modified PBac (24/5/2022)
         * */
        if (!question.Answers?.length && question.Type === Enumeration.QuestionType.Essay) {
          question.Answers.push({
            Correct: false,
            SortOrder: 1
          })
        }
        question.Answers.forEach(function (item) {
          var answer = {
            Correct: item.Correct,
            Content: item.Content,
            Image: item.Image,
            SortOrder: item.SortOrder,
            AnswerAttachment: item.AnswerAttachment,
            Column: item.Column
          }
          questionSubmit.Answers.push(answer)
        })
        question.CorectAnswers?.forEach(function (item) {
          var answer = {
            Correct: item.Correct,
            Content: item.Content,
            Image: item.Image,
            SortOrder: item.SortOrder,
            AnswerAttachment: item.AnswerAttachment
          }
          questionSubmit.CorectAnswers.push(answer)
        })
        state.submitExercise.Questions.push(questionSubmit)
      })
      state.studentExercise.IsStudentCompensate = exerciseCard.IsStudentCompensate
    },

    // clone dữ liệu câu hỏi sang param submit để nộp bài
    cloneExerciseCardToStudentExam (state, exerciseCard) {
      state.exerciseCard = { ...exerciseCard }
      let time = exerciseCard?.RemainingTime || 0
      if (time === 0) {
        time = exerciseCard.Time * 60
      }
      if (exerciseCard.ParentQuestions?.length > 0) {
        exerciseCard.ParentQuestions?.forEach((item) => {
          const groupQuestion = exerciseCard.Questions.filter(
            (question) => question.ParentID === item.SortOrder
          )
          if (groupQuestion.length > 0) {
            const startIndex = groupQuestion[0].SortOrder
            const endIndex = groupQuestion[groupQuestion.length - 1].SortOrder

            let numberQuestion = formatText(startIndex, 2, '0')
            if (endIndex && startIndex !== endIndex) {
              numberQuestion = `${numberQuestion} - ${formatText(
                endIndex,
                2,
                '0'
              )}`
            }
            item.ParentName = numberQuestion
          }
        })
      }
      state.submitExercise = {
        SubmitExerciseID: state.exerciseSaveDraft,
        ExerciseCardID: exerciseCard?.ExerciseCardID,
        TeacherExamPeriodID: exerciseCard?.TeacherExamPeriodID,
        Title: exerciseCard?.Title,
        Note: exerciseCard.Note,
        Status: 0,
        Replay: exerciseCard.Replay,
        Time: time,
        Questions: [],
        SubmitAnswer: exerciseCard.SubmitAnswer,
        Background: exerciseCard.Background,
        ParentQuestions: exerciseCard?.ParentQuestions
      }
      exerciseCard.Questions =
        exerciseCard.Questions !== undefined ? exerciseCard.Questions : []

      exerciseCard.Questions.forEach(function (question) {
        let ParentQuestion = null
        if (question.ParentID) {
          ParentQuestion = exerciseCard.ParentQuestions?.find(
            (item) => item.SortOrder === question.ParentID
          )
        }

        const { Type, SortOrder, Done, Content, Attachments, IsCheck, MaxPoint, ParentID } =
          question
        const questionSubmit = {
          Type,
          SortOrder,
          Done,
          Content,
          Attachments,
          IsCheck,
          MaxPoint,
          ParentID,
          Answers: [],
          ParentQuestion,
          MappingAnswer: []
        }
        /**
         * Care lỗi dữ liệu do bug trước đó từ tính năng trích rút
         * Nếu là câu tự luận và không có đáp án thì push 1 đáp án default vào để binding dữ liệu
         * @modified PBac (24/5/2022)
         * */
        if (!question.Answers?.length && question.Type === Enumeration.QuestionType.Essay) {
          question.Answers.push({
            Correct: false,
            SortOrder: 1
          })
        }
        question.Answers.forEach(function (item) {
          var answer = { ...item }
          questionSubmit.Answers.push(answer)
        })
        state.submitExercise.Questions.push(questionSubmit)
      })
      state.submitExercise.ParentQuestions = exerciseCard.ParentQuestions
    },
    /**
     * Cập nhật trạng thái Submit
     * @param {*} state
     * @param {*} status
     */
    updateStatusSubmitExercise (state, status) {
      state.submitExercise.Status = status
    },

    /**
     * Cập nhật background
     * @param {*} state
     * @param {*} url
     */
    updateBackgroundExercise (state, url) {
      state.submitExercise.Background = url
    },

    // Cập nhật số lượng bài tập theo từng loại
    updateCountExercise (state, countExercise) {
      state.countExercise = countExercise
    },
    // Cập nhật tab đang được active
    updateTabActive (state, tabActive) {
      if (tabActive != null) {
        state.tabActive = tabActive
      } else {
        state.tabActive = Enumeration.TabActive.All
      }
    },
    // Cập nhật tab đang được active
    updateTabActiveClassroom (state, tabActiveClassroom) {
      if (tabActiveClassroom != null) {
        state.tabActiveClassroom = tabActiveClassroom
      } else {
        state.tabActiveClassroom = Enumeration.TabActive.All
      }
    },
    // cập nhật ghi chú
    updateNoteExercise (state, noteExercise) {
      state.submitExercise.Note = noteExercise
    },

    /**
     * Cập nhật ID bài lưu nháp và trạng thái làm tiếp theo
     */
    updateSubmitExerciseSaveDraft (state, params) {
      state.exerciseSaveDraft = params.SubmitExerciseID
      state.isReplay = params.IsReplay
    },

    /**
     * @description cập nhật thông tin bài lưu nháp
     * @param {*} state
     * @param {*} param
     */
    setExerciseSaveDraft (state, param) {
      state.exerciseSaveDraft = param
    },

    // Cập nhật ID bài lưu nháp
    updateSubmitExerciseId (state, submitExerciseId) {
      state.submitExercise.SubmitExerciseID = submitExerciseId
    },
    // cập nhật ID bài tập của học sinh
    updateStudentExerciseID (state, id) {
      state.studentExercise.Id = id
    },

    // Cập nhật dữ liệu bài tập
    setExercise (state, exercise) {
      state.exercise = exercise
    },
    // Cập nhật giá trị cho state
    updateIsClickTabIndex (state, isClickTabIndex) {
      state.isClickTabIndex = isClickTabIndex
    },

    // Cập nhật theme làm bài tập
    updateExerciseThemeIndex (state, exerciseThemeIndex) {
      state.exerciseThemeIndex = exerciseThemeIndex
    },

    // Cập nhật state lưu học sinh đang làm bài dở hay không
    updateIsNotDoneExercise (state, isNotDoneExercise) {
      state.isNotDoneExercise = isNotDoneExercise
    },
    // set chi tiết 1 bài tập để làm bài
    setExerciseDetail (state, exerciseDetail) {
      state.exerciseDetail = exerciseDetail
      state.exerciseDetail.Note = state?.noteDetail
      state.submitExercise = Object.assign(exerciseDetail, {
        SubmitExerciseID: state.exerciseSaveDraft,
        ExerciseReferenceID:
          state.exercise.SourceType === Enumeration.PracticeType.ExerciseStore
            ? ''
            : state.exercise.Id,
        ExerciseStoreID:
          state.exercise.SourceType === Enumeration.PracticeType.ExerciseStore
            ? state.exercise.Id
            : ''
      })
    },

    // Cập nhật tabActive trạng thái bài tập của học sinh
    updateTabActiveV2 (state, tabActive) {
      state.tabActiveV2 = tabActive
    },

    resetExerciseListByReference (state, reference) {
      state[reference] = {}
    },

    setExercisesNotFinish (state, exercisesNotFinish) {
      if (state.exercisesNotFinish?.PageData?.length > 0) {
        state.exercisesNotFinish.PageData = state.exercisesNotFinish.PageData.concat(exercisesNotFinish.PageData)
      } else {
        state.exercisesNotFinish = exercisesNotFinish
      }
    },

    setExerciseFinishedHaveResult (state, exercisesFinishedHaveResult) {
      if (state.exercisesFinishedHaveResult?.PageData?.length > 0) {
        state.exercisesFinishedHaveResult.PageData = state.exercisesFinishedHaveResult.PageData.concat(exercisesFinishedHaveResult.PageData)
      } else {
        state.exercisesFinishedHaveResult = exercisesFinishedHaveResult
      }
    },

    setExerciseFinishedNoResult (state, exercisesFinishedNoResult) {
      if (state.exercisesFinishedNoResult?.PageData?.length > 0) {
        state.exercisesFinishedNoResult.PageData = state.exercisesFinishedNoResult.PageData.concat(exercisesFinishedNoResult.PageData)
      } else {
        state.exercisesFinishedNoResult = exercisesFinishedNoResult
      }
    },

    setSelectedQuestionIndex (state, selectedQuestionIndex) {
      state.selectedQuestionIndex = selectedQuestionIndex
    }
  },

  actions: {
    /**
     * @description Lấy danh sách bài tập học sinh
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getStudentExercises (context, param) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(
          `/exercise-studentid?Type=${param.Type}&SubjectCode=${
            param.Subject ? param.Subject : ''
          }&TextSearch=${param.TextSearch}&pageIndex=${
            param.pageIndex
          }&pageSize=${param.pageSize}&ClassCode=${param.ClassCode}`
        )
          .then((res) => {
            context.commit('setStudentExercise', res.Data.PageData)
            // lần đầu check tồn tại tham khảo sẽ không lấy tổng số bản ghi
            if (!param.SetEmpty) {
              context.commit('setTotalExercise', res.Data.Total)
            }

            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách bài tập chưa hoàn thành của học sinh
     * @author PBac
     * @createdDate (9/5/2022)
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getStudentExerciseNotFinish (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync('exercises-not-finish', { params: params })
          .then(res => {
            if (res.Data) {
              context.commit('setExercisesNotFinish', res.Data)
            }
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy danh sách bài tập đã hoàn thành của học sinh
     * @author PBac
     * @createdDate (10/5/2022)
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getStudentExerciseFinished (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync('exercises-finished', { params: params })
          .then(res => {
            if (res.Data) {
              if (res.Data.ListExerciseHaveResult) {
                context.commit('setExerciseFinishedHaveResult', res.Data.ListExerciseHaveResult)
              }
              if (res.Data.ListExerciseNoResult) {
                context.commit('setExerciseFinishedNoResult', res.Data.ListExerciseNoResult)
              }
            }
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description lấy danh sách bài tập theo thứ tự chưa nộp-> chưa nộp còn hạn -> đã nộp của 1 học sinh
     * @author TTLONG
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */

    getExerciseMission (context, param) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(
          `/exercise-mission?pageIndex=${param.pageIndex}&pageSize=${param.pageSize}`
        )
          .then((res) => {
            context.commit('setAllStudentExercise', res.Data.PageData)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập học sinh theo Id
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getStudentExerciseByID (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(`/exercise-detail?id=${params}`)
          .then((res) => {
            context.commit('setStudentExerciseByID', res.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Log ELK
     * @param {*} context
     * @param {*} params
     * @returns
     */
    logELK (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.postAsync('/log-elk', params)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập học sinh theo Id và theo lớp
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getCountExercise (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(
          `/count?classCode=${params?.ClassCode || ''}&subjectCode=${
            params?.SubjectCode ? params?.SubjectCode : ''
          }`
        )
          .then((res) => {
            context.commit('updateCountExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập học sinh theo Id và theo lớp
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getExerciseByIDAndClassCode (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(`/classroom-exercise/${params}`)
          .then((res) => {
            context.commit('setStudentExercise', res.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Thực hiện chọn câu hỏi
     * @param {*} context
     * @param {*} params
     */
    setSelectdQuestionBySortOrder (context, params) {
      context.commit('setSelectedQuestion', params)
    },
    /**
     * Cập nhật đáp án cho từng câu hỏi
     * @param {*} context
     * @param {*} params
     */
    updateAnswerForQuestion (context, params) {
      context.commit('updateAnswerForQuestion', params)
      context.commit('setSelectedQuestion', params.sortOrderQuestion)
    },
    /**
     * @description Hiện tại chưa có API nên fix dữ liệu khi mới vào màn hình mặc định chọn câu hỏi đầu tiên
     * @author NVHUY1
     * @param {*} context
     * @param {*} studentExercises
     * @returns
     */
    getStudentExerciseByIDAndClassCode (context, params) {
      // Convert dữ liệu trả về sang param lưu
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(
          `/submit-exercise?studentExerciseID=${params.StudentExerciseID}&submitExercisesID=${params.SubmitExercisesID}&isReplay=${params.IsReplay}&exerciseCardID=${params.exerciseCardID}`
        )
          .then((res) => {
            if (res.Data) {
              const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)

              context.commit('cloneExerciseCardToSubmitExercise', exercise)
              context.commit('setSelectedQuestion', 1)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật trạng thái bài nộp là lưu nháp hay nộp bài
     * @param {*} context
     * @param {*} status
     */
    updateStatusSubmitExercise (context, status) {
      context.commit('updateStatusSubmitExercise', status)
    },
    /**
     * @description hàm submit exercise
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    submitStudentExercise (context, submitExercise) {
      return new Promise((resolve, reject) => {
        const exercise = handleMappingAnswer(submitExercise, Enumeration.HandlePairingAnswerType.Convert)

        StudentExerciseAPI.postAsync('/SubmitExercise', exercise)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Cập nhật thông tin tab đang active
     * @param {*} context
     * @param {*} params
     */
    updateTabActive (context, params) {
      context.commit('updateTabActive', params)
    },
    /**
     * Cập nhật thông tin tab đang active bên lớp học
     * @param {*} context
     * @param {*} params
     */
    updateTabActiveClassroom (context, params) {
      context.commit('updateTabActiveClassroom', params)
    },
    /**
     * Cập nhật thông tin tab đang active
     * @param {*} context
     * @param {*} params
     */
    updateNoteExercise (context, noteExercise) {
      context.commit('updateNoteExercise', noteExercise)
    },
    /**
     * @description hàm submit exercise
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    getSubmitExerciseById (context, submitExercisesID) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.postAsync(`submit-exercise/${submitExercisesID}`)
          .then((res) => {
            context.commit('setSubmitExercise', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * @description Sửa trạng thái của học sinh
     * @author NTQuy
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateNoteExerciseById (context, params) {
      const bodyUpdate = {
        Id: params.StudentExerciseID,
        Note: params.Note,
        UpdateFields: ['Note']
      }
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.putAsync(`/${params.StudentExerciseID}`, bodyUpdate)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Sửa trạng thái bài tập tham khảo
     * @author BNDung
     * @param {*} context
     * @param {*} classroom
     * @returns
     */
    updateIsReferExerciseById (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.putAsync(
          `/update-is-reference?classID=${params.ClassID}&isReference=${params.IsRefer}`
        )
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // cập nhật id submitexercise lưu nháp
    updateSubmitExerciseSaveDraft (context, params) {
      context.commit('updateSubmitExerciseSaveDraft', params)
    },

    /**
     * Đẩy dữ liệu vào pewview câu trả lời
     * @param {*} context
     * @param {*} param
     */
    getAnswerAttachment (context, param) {
      context.commit('setAnswerAttachment', param)
    },

    /**
     * Đẩy dữ liệu vào pewview câu trả lời
     * @param {*} context
     * @param {*} param
     */
    getCorrectAnswerAttachment (context, param) {
      context.commit('setCorrectAnswerAttachment', param)
    },

    /**
     * Show màn hình preview answer hoặc compare answer
     * @param {*} context
     * @param {*} param
     */
    getPreviewAnswer (context, param) {
      context.commit('setPreviewAnswer', param)
    },

    /**
     * Lấy dữ liệu các file preview từ học sinh làm bài
     * @author BNDung
     * @param {*} context
     * @param {*} submitExercisesID
     */
    getPreviewAttachmentStudent (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(
          `preview-submit-exercise?studentExerciseID=${params.studentExercisesID}&submitExercisesID=${params.submitExercisesID}`
        )
          .then((res) => {
            const exercise = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)
            context.commit('setPreviewAttachment', exercise)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cập nhật SubmitExerciseId sau khi lưu nháp thành công
     */
    updateSubmitExerciseId (context, submitExercisesID) {
      context.commit('updateSubmitExerciseId', submitExercisesID)
    },

    /**
     *
     * @param {*} context
     * @param {*} param
     */
    getExamById (context, param) {
      return new Promise((resolve, reject) => {
        StudentExamAPI.getAsync(
          `do?id=${param.Id}&examPeriodID=${param.TeacherExamPeriodID}&message=${param.Message}`
        )
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              const exam = handleMappingAnswer(res.Data, Enumeration.HandlePairingAnswerType.Revert)

              context.commit('cloneExerciseCardToStudentExam', exam)
              context.commit('setSelectedQuestion', 1)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập theo exerciseCardId
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getExerciseByExerciseCardId (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync('exercise-card', { params: params })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setExercise', res.Data.ExerciseStore)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập theo exerciseStoreId
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getExerciseByExerciseStoreId (context, params) {
      return new Promise((resolve, reject) => {
        MISAStoreAPI.getAsync('detail', { params: params })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setExercise', res.Data)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy dữ liệu bài tập theo exerciseReferenceId
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getExerciseByExerciseReferenceId (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseReferAPI.getAsync('print', { params: params })
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setExercise', res.Data)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách bài tập cho bài tập tổng hợp
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getSubjectsForCompoundExercise (context) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync('compound-exercise/subjects')
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setSubjects', res.Data)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy danh sách câu hỏi cho bài tập tổng hợp
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getQuestionsForCompoundExercise (context, params) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync(`compound-exercise/questions?subjectCode=${params}`)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              const data = handleMappingAnswer({ Questions: res.Data }, Enumeration.HandlePairingAnswerType.Revert)
              context.commit('setQuestionCompoundExercises', data.Questions)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * kiểm tra có bài tập tổng hợp không
     * @param {*} context
     * @returns
     */
    checkCompoundExercise (context) {
      return new Promise((resolve, reject) => {
        StudentExerciseAPI.getAsync('compound-exercise/check-exists')
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setIsCompoundExercise', res.Data)
            }
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
